import styled from 'styled-components';

export const WidgetCard = styled.div`
  background-color: ${({ theme }) => theme.colors.White};
  border: 1px solid ${({ theme }) => theme.colors.Grey4};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`;

export const WidgetCardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
`;

export const WidgetCardHeadings = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const WidgetCardHeaderAction = styled.div`
  flex-shrink: 0;
`;

export const WidgetCardTitle = styled.h3`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin: 0;
`;

export const WidgetCardSubtitle = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const WidgetCardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const WidgetCardLoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
`;
